import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { Field } from 'formik';

import deleteIcon from 'images/icons/invite/delete.svg';
import ExternalLink from 'components/Widgets/ExternalLink';
import {
  TextField,
  SelectFieldV2,
  FileField,
} from 'ui/FormElement';

export default function Document({
  record, index, helpers, setFieldValue,
}) {
  const { remove } = helpers;

  return (
    <div
      key={index}
      className={`mb20 ${record.destroy ? 'd-none' : ''}`}
      style={{ display: 'flex' }}
    >
      <Field
        type="hidden"
        name={`documents.${index}.id`}
      />

      <Field
        type="hidden"
        name={`documents.${index}.destroy`}
        value={false}
      />

      <div style={{ flexGrow: 1 }}>
        <TextField
          name={`documents.${index}.title`}
          label={(
            <>
              <span>Title</span>
              <abbr title="required">*</abbr>
            </>
          )}
        />

        <SelectFieldV2
          name={`documents.${index}.content_type`}
          placeholder="Choose Document Type"
          isMulti={false}
          options={[
            { label: 'Link', value: 'link' },
            { label: 'Video', value: 'video' },
            { label: 'File', value: 'file' },
          ]}
          label={(
            <>
              <span>Document Type</span>
              <abbr title="required">*</abbr>
            </>
          )}
        />

        {record.content_type === 'link' && (
          <TextField
            name={`documents.${index}.link`}
            label={(
              <>
                <span>URL</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />
        )}

        {record.content_type === 'video' && (
          <TextField
            name={`documents.${index}.link`}
            label={(
              <>
                <span>Video URL</span>
                <abbr title="required">*</abbr>
              </>
            )}
          />
        )}

        {record.content_type === 'file' && (
          <>
            <FileField
              name={`documents.${index}.document`}
              label={(
                <>
                  <span>File</span>
                  <abbr title="required">*</abbr>
                </>
              )}
            />

            {record.document_file_name && (
              <div className="mb10" style={{ marginTop: '-10px' }}>
                Currently uploaded file:
                {' '}
                <ExternalLink
                  href={record.document_url}
                  variant={null}
                >
                  {record.document_file_name}
                </ExternalLink>
              </div>
            )}
          </>
        )}
      </div>

      <div style={{ alignSelf: 'center' }}>
        <Button
          bsStyle="link"
          onClick={() => {
            if (record.id) {
              setFieldValue(`documents.${index}.destroy`, true);
            } else {
              remove(index);
            }
          }}
        >
          <img src={deleteIcon} alt="delete document" />
        </Button>
      </div>
    </div>
  );
}

Document.propTypes = {
  record: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  helpers: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};
